import { RootState } from "../../../store";

export const changePassSelector = (state: RootState) => state.changePass;
